import { Outlet } from "react-router-dom";
import Sidebar from "@/components/Sidebar";
import Topbar from "@/components/Topbar";
import Footer from "@/components/Footer";
import FloatingChat from "@/components/FloatingChat";
import { Seo } from "@/components/Seo";
import { useAuth } from "@/context/AuthContext";

export default function Layout() {
  const { user } = useAuth();
  return (
    <div className={`min-h-screen flex bg-[#07080E] text-slate-100 ${user?.is_demo ? "pt-7" : ""}`}>
      {user?.is_demo && <div data-testid="demo-banner" className="fixed top-0 left-0 right-0 z-[60] bg-amber-400 text-black text-center text-xs font-semibold py-1.5">Demo account — data resets daily · payments are simulated (test mode) · daily AI credit cap applies</div>}
      <Seo title="Vectra Studio" description="Vectra creator workspace" noindex />
      <Sidebar />
      <div className="flex-1 min-w-0 flex flex-col">
        <Topbar />
        <main className="flex-1 overflow-y-auto">
          <Outlet />
          <Footer />
        </main>
      </div>
      <FloatingChat />
    </div>
  );
}
